import BaseApiServiceV2 from "./BaseApiServiceV2";

class BuildingsService extends BaseApiServiceV2 {
    /**
     * @param {String} id
     * @returns Promise<Object>
     * @memberof SearchService
     */

    getBuildingDetailsByID(id: string) {
        return this.apiGet(`/building/sfid/${id}`);
    }
    getNearByBuildings(latitude: number, longitude: number, recordsLimit: number) {
        return this.apiGet(
            `/building/nearby?latitude=${latitude}&longitude=${longitude}&radius=13&limit=${recordsLimit}`
        );
    }
    getBuildings(
        country: string,
        search: string,
        buildingGrade: string,
        page: number,
        city: string,
        limit: number
    ) {
        return this.apiGet(
            `/building/country/${country}/buildings?search=${search}&buildingGrade=${buildingGrade}&page=${page}&limit=${limit}&city=${city}`
        );
    }

}
export default new BuildingsService();
